import { useParams } from '@solidjs/router';
import { createMagicDoorContext } from '~/contexts/utils';
import { leaseMoveOutRepository } from '~/repositories/leaseMoveOutRepository';
import { createLazyResource, createMutation } from '~/utils/resource';
import type { LeaseMoveOutRequestDto } from '~/swagger/Api';

const [MoveOutRequestProvider, useMoveOutRequests] = createMagicDoorContext('MoveOutRequestContext', () => {
  const { leaseId } = useParams<{ leaseId: string }>();

  const [requests, { refetch: fetchRequests }] = createLazyResource(async () => {
    if (!leaseId) return [];
    return leaseMoveOutRepository.getMoveOutRequests(leaseId);
  });

  const acceptRequestMutation = createMutation(async (request: LeaseMoveOutRequestDto) => {
    if (!leaseId) return;
    await leaseMoveOutRepository.acceptMoveOutRequest(leaseId, request.id);
    fetchRequests();
  });

  const rejectRequestMutation = createMutation(async (request: LeaseMoveOutRequestDto) => {
    if (!leaseId) return;
    await leaseMoveOutRepository.rejectMoveOutRequest(leaseId, request.id);
    fetchRequests();
  });

  return {
    requests,
    fetchRequests,
    acceptRequest: acceptRequestMutation,
    rejectRequest: rejectRequestMutation,
  };
});

export { MoveOutRequestProvider, useMoveOutRequests };
